import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import {
    Button,
    Checkbox,
    Col,
    Drawer,
    Input,
    InputGroup,
    InputPicker,
    Row
} from 'rsuite';
import { limitCharacterLength, tenthsDecimalInputMask, textNumbersSymbolsInputmask } from '../../../../resources/logic/inputMasks';
import DebouncedButton from '../../../componentsGeneral/Rsuite/Button/DebouncedButton';


const styles = {
    // width: 300,
    marginBottom: 5,
    width: '100%'
};


const mountRef = React.createRef();

const AddNewSkuDrawer = ({ onChangeState, show, placement, confirm, close, state, ...props }) => (

    <Drawer show={state.showAddNewSkuDrawer} onHide={close} placement={placement} style={props.isMobile ? { width: '350px' } : { width: '650px' }}    >
        <Drawer.Header>
            <Drawer.Title>Add New Item</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>

            <Container maxWidth={false} style={{ width: '100%' }}>

                <Paper elevation={3} style={{ padding: '15px', marginTop: '15px', width: '100%' }}>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>SKU:</InputGroup.Addon>
                            <Input value={state.addNewSku} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewSku')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 50)} />
                        </InputGroup>
                    </Row>

                    <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Warehouse:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Warehouse...'}
                                value={state.addNewWarehouseID}
                                onChange={(e) => { onChangeState(e, 'addNewWarehouseID') }}
                                data={state.warehouseArray}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                            />
                        </InputGroup>
                    </Row>

                    <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Customer:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Customer...'}
                                value={state.addNewCustomerID}
                                onChange={(e) => { onChangeState(e, 'addNewCustomerID') }}
                                data={state.customerArray}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                            />
                        </InputGroup>
                    </Row>

                    <Row >
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Customer Ref:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Customer Ref...'}
                                value={state.addNewCustomerRef}
                                onChange={(e) => { onChangeState(e, 'addNewCustomerRef') }}
                                data={props.InventoryCustomerRefData}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                                creatable
                            />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Project:</InputGroup.Addon>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Project...'}
                                value={state.addNewProject}
                                onChange={(e) => { onChangeState(e, 'addNewProject') }}
                                data={props.InventoryProjectData}
                                style={{ width: '100%' }}
                                block
                                cleanable={true}
                                creatable
                            />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>PGA Flag:</InputGroup.Addon>
                            <Checkbox checked={state.addNewPGAFlag} onChange={(e, checked) => onChangeState(checked, 'addNewPGAFlag')} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Name:</InputGroup.Addon>
                            <Input value={state.addNewProductName} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewProductName')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>


                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Details:</InputGroup.Addon>
                            <Input value={state.addNewProductDetails} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewProductDetails')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product URL:</InputGroup.Addon>
                            <Input value={state.addNewProductURL} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewProductURL')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Product Country of Origin:</InputGroup.Addon>
                            <Input value={state.addNewProductCountryofOrigin} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewProductCountryofOrigin')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>HTS Code:</InputGroup.Addon>
                            <Input value={state.addNewHTSCode} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewHTSCode')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 10)} />
                        </InputGroup>
                    </Row>




                    <Row>
                        <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputGroup.Addon>Notes:</InputGroup.Addon>
                            <Input value={state.addNewNotes} className={'custom-input-number'} onChange={(e) => onChangeState(e, 'addNewNotes')} scrollable={false} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 400)} />
                        </InputGroup>
                    </Row>


                    <Row>
                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <Input value={state.addLength}
                                    placeholder={'Length'}
                                    onChange={(e) => { onChangeState(e, 'addLength') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <Input value={state.addWidth}
                                    placeholder={'Width'}
                                    onChange={(e) => { onChangeState(e, 'addWidth') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <Input value={state.addHeight}
                                    placeholder={'Height'}
                                    onChange={(e) => { onChangeState(e, 'addHeight') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>

                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <InputPicker preventOverflow
                                    container={() => mountRef.current}
                                    placeholder={'Unit of Measure...'}
                                    value={state.addUomID}
                                    onChange={(e) => { onChangeState(e, 'addUomID') }}
                                    data={props.CommonUnitOfMeasureData}
                                    style={{ width: '100%' }}
                                    block
                                    cleanable={false}
                                />
                            </InputGroup>
                        </Col>

                    </Row>






                    <Row>
                        <Col md={18} sm={18}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                                <Input value={state.addWeight}
                                    placeholder={'Weight'}
                                    onChange={(e) => { onChangeState(e, 'addWeight') }}
                                    onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
                                />
                            </InputGroup>
                        </Col>


                        <Col md={6} sm={6}>
                            <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
                            <InputPicker preventOverflow
                                container={() => mountRef.current}
                                placeholder={'Unit of Weight...'}
                                value={state.addUowID}
                                onChange={(e) => { onChangeState(e, 'addUowID') }}
                                data={props.CommonUnitOfWeightData}
                                style={{ width: '100%' }}
                                block
                                cleanable={false}
                            />
                            </InputGroup>
                        </Col>

                    </Row>







                </Paper>



                <Paper elevation={3} style={{ padding: '15px', marginTop: '15px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <DebouncedButton onClick={confirm} buttonText="Save" />

                        <Button variant="contained" color="primary" onClick={(e) => close(e)} style={{ marginLeft: '10px' }}>
                            Cancel
                        </Button>
                    </div>
                </Paper>





                <br />
                <br />


            </Container>


        </Drawer.Body>
        <Drawer.Footer>
            <br />
        </Drawer.Footer>

    </Drawer>

);



AddNewSkuDrawer.defaultProps = {
    show: false
};

export default AddNewSkuDrawer;








// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Length:</InputGroup.Addon>
// <Input value={state.addLength}
//     onChange={(e) => { onChangeState(e, 'addLength') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>


// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Width:</InputGroup.Addon>
// <Input value={state.addWidth}
//     onChange={(e) => { onChangeState(e, 'addWidth') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>

// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Height:</InputGroup.Addon>
// <Input value={state.addHeight}
//     onChange={(e) => { onChangeState(e, 'addHeight') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>

// <Row >
// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//     <InputGroup.Addon>Unit of Measure:</InputGroup.Addon>
//     <InputPicker preventOverflow
//         container={() => mountRef.current}
//         placeholder={'Unit of Measure...'}
//         value={state.addUomID}
//         onChange={(e) => { onChangeState(e, 'addUomID') }}
//         data={props.InventoryCustomerRefData}
//         style={{ width: '100%' }}
//         block
//         cleanable={false}
//     />
// </InputGroup>
// </Row>





// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
// <InputGroup.Addon>Weight:</InputGroup.Addon>
// <Input value={state.addWeight}
//     onChange={(e) => { onChangeState(e, 'addWeight') }}
//     onInput={(e) => e.target.value = tenthsDecimalInputMask(e)}
// />
// </InputGroup>


// <Row >
// <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//     <InputGroup.Addon>Unit of Weight:</InputGroup.Addon>
//     <InputPicker preventOverflow
//         container={() => mountRef.current}
//         placeholder={'Unit of Weight...'}
//         value={state.addUowID}
//         onChange={(e) => { onChangeState(e, 'addUowID') }}
//         data={props.InventoryCustomerRefData}
//         style={{ width: '100%' }}
//         block
//         cleanable={false}
//     />
// </InputGroup>
// </Row>